// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sop6","col":"styles_col__5PTOP"};